import { render, staticRenderFns } from "./AccountUpgrade.vue?vue&type=template&id=40742dc4&scoped=true"
import script from "./AccountUpgrade.vue?vue&type=script&lang=js"
export * from "./AccountUpgrade.vue?vue&type=script&lang=js"
import style0 from "./AccountUpgrade.vue?vue&type=style&index=0&id=40742dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40742dc4",
  null
  
)

export default component.exports